var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,11c2.7,0,5.1,1,7,2.7c1.8,1.7,3,4,3,6.6V21H0v-0.6c0.1-2.6,1.2-5,3-6.6c1.7-1.6,4.1-2.7,6.6-2.7L10,11z  M10,13c-2.1,0-4.2,0.8-5.6,2.2c-1.1,1-1.9,2.3-2.2,3.7l0,0.1h15.6l0-0.1c-0.3-1.3-1-2.5-2-3.5l-0.2-0.2C14.1,13.8,12.1,13,10,13z  M10,0c2.7,0,5,2.2,5,5c0,2.7-2.1,4.9-4.8,5L10,10c-2.7,0-5-2.2-5-5c0-2.7,2.1-4.9,4.8-5L10,0z M10,2C8.3,2,7,3.3,7,5 c0,1.7,1.3,3,3,3c1.6,0,3-1.4,3-3C13,3.3,11.7,2,10,2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.550b96c0b3db58b2f47dda924fbd3e18.svg";
export { ForwardRef as ReactComponent };